module.exports = __webpack_public_path__ + "static/media/convective-icon-moderate.641d2b47.svg";